<template id="custom-select">
  <ValidationProvider :name="name" :rules="validationRules" v-slot="v" slim>
    <div class="wide field" v-bind:class="[{ 'error': v.validated && v.invalid }, size]">
      <label>{{ label }}</label>
      <div class="ui input action">
        <input v-model="input" v-on:focus="$event.target.select()"  :type="type" :value="value" @change="change" ref="myinput"  v-mask="mask" :disabled="disabledInput" />
        <button
          type="button"
          class="ui button" v-bind:class="[customClass]"
          @click="click" :disabled="input == ''" >
          <i v-if="enableIcon" v-bind:class="[iconClass]"></i>
          <slot></slot>
        </button>
      </div>
      <span v-if="v.validated && v.invalid" class="ui red basic label error">{{ v.errors[0] }}</span>
    </div>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'InputLabeledButton',
  components: {
    ValidationProvider,
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    iconClass: {
      type: String,
    },
    customClass: {
      type: String,
    },
    name: {
      type: String,
    },
    value: {
      type: [Number, String],
    },
    label: {
      type: String,
      default: 'Sem Label',
    },
    validationRules: {
      type: String,
      default: '',
    },
    mask: {
      type: String,
    },
    size: {
      type: String,
      default: 'four',
    },
    apiRoute: {
      type: String,
      default: '',
    },
    disabledInput: {
      type: Boolean,
      default: false,
    },
    enableIcon: {
      type: Boolean,
      default: false,
    },
    disabledCache: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input: this.value,
    };
  },
  methods: {
    click() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.input).then(() => {
          this.$alertify.success('Link copiado com sucesso !!');
        });
      }
    },
    change() {
    },
  },
  watch: {
    value: {
      immediate: false,
      handler(value) {
        this.input = value;
      },
    },
  },
};
</script>

<style lang="scss">
  span.ui.basic.red.label.error {
    border: none;
    background-color: transparent !important;
    padding: 0;
    font-size: 11px;
  }
</style>
